var Interface = require('../core');
var numeral = require('numeral');
var _ = require('lodash');

var matchesMinMaxRules = function matchesMinMaxRules(val, rules) {
  var isValid = true;

  if (rules) {
    if (rules.min !== undefined) {
      isValid = isValid && val >= rules.min;
    }

    if (rules.max !== undefined) {
      isValid = isValid && val <= rules.max;
    }
  }

  return isValid;
};

var isTrueNumber = function isTrueNumber(val) {
  return !_.isNaN(val) && this.discoverType(val) === 'number';
};

var REMOVE_NON_NUMERIC = /[^0-9.]/g;

Interface.type('integer', {
  defaultValue: 0,
  convertToSource: function (syncProp, dtdRequirement, source, sync) {
    return parseInt((syncProp + '').replace(REMOVE_NON_NUMERIC, ''), 10);
  },
  convertToSync: function (sourceProp, dtdRequirement, source, sync) {
    var value = parseInt(sourceProp, 10);
    if (!!dtdRequirement.rules && dtdRequirement.rules.format) {
      value = numeral(value).format(dtdRequirement.rules.format);
    }

    return value;
  },
  isOfType: function verifyTypeInt(val, req) {
    return isTrueNumber.call(this, val) && Math.floor(val) === val && matchesMinMaxRules(val, req.rules);
  }
})
  .type('real', {
    defaultValue: 0.0,
    convertToSource: function (syncProp, dtdRequirement, source, sync) {
      return parseFloat((syncProp + '').replace(REMOVE_NON_NUMERIC, ''));
    },
    convertToSync: function (sourceProp, dtdRequirement) {
      var value = parseFloat(sourceProp);
      if (!!dtdRequirement.rules && dtdRequirement.rules.format) {
        value = numeral(value).format(dtdRequirement.rules.format);
      }

      return value;
    },
    isOfType: function verifyTypeNumber(val, req) {
      return isTrueNumber.call(this, val) && matchesMinMaxRules(val, req.rules);
    }
  })
  .type('number', Interface.type('real'));



// WEBPACK FOOTER //
// ./app/vendor/utility-js-interface/src/types/numeric.js